import { render, staticRenderFns } from "./expressage.vue?vue&type=template&id=632a91c0&scoped=true"
import script from "./expressage.vue?vue&type=script&lang=js"
export * from "./expressage.vue?vue&type=script&lang=js"
import style0 from "./expressage.vue?vue&type=style&index=0&id=632a91c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a91c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632a91c0')) {
      api.createRecord('632a91c0', component.options)
    } else {
      api.reload('632a91c0', component.options)
    }
    module.hot.accept("./expressage.vue?vue&type=template&id=632a91c0&scoped=true", function () {
      api.rerender('632a91c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/groupManagement/expressage.vue"
export default component.exports